/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetCorporationsCorporationIdContracts200Ok
 */
export interface GetCorporationsCorporationIdContracts200Ok {
    /**
     * Who will accept the contract
     * @type {number}
     * @memberof GetCorporationsCorporationIdContracts200Ok
     */
    acceptorId: number;
    /**
     * ID to whom the contract is assigned, can be corporation or character ID
     * @type {number}
     * @memberof GetCorporationsCorporationIdContracts200Ok
     */
    assigneeId: number;
    /**
     * To whom the contract is available
     * @type {string}
     * @memberof GetCorporationsCorporationIdContracts200Ok
     */
    availability: GetCorporationsCorporationIdContracts200OkAvailabilityEnum;
    /**
     * Buyout price (for Auctions only)
     * @type {number}
     * @memberof GetCorporationsCorporationIdContracts200Ok
     */
    buyout?: number;
    /**
     * Collateral price (for Couriers only)
     * @type {number}
     * @memberof GetCorporationsCorporationIdContracts200Ok
     */
    collateral?: number;
    /**
     * contract_id integer
     * @type {number}
     * @memberof GetCorporationsCorporationIdContracts200Ok
     */
    contractId: number;
    /**
     * Date of confirmation of contract
     * @type {Date}
     * @memberof GetCorporationsCorporationIdContracts200Ok
     */
    dateAccepted?: Date;
    /**
     * Date of completed of contract
     * @type {Date}
     * @memberof GetCorporationsCorporationIdContracts200Ok
     */
    dateCompleted?: Date;
    /**
     * Expiration date of the contract
     * @type {Date}
     * @memberof GetCorporationsCorporationIdContracts200Ok
     */
    dateExpired: Date;
    /**
     * Сreation date of the contract
     * @type {Date}
     * @memberof GetCorporationsCorporationIdContracts200Ok
     */
    dateIssued: Date;
    /**
     * Number of days to perform the contract
     * @type {number}
     * @memberof GetCorporationsCorporationIdContracts200Ok
     */
    daysToComplete?: number;
    /**
     * End location ID (for Couriers contract)
     * @type {number}
     * @memberof GetCorporationsCorporationIdContracts200Ok
     */
    endLocationId?: number;
    /**
     * true if the contract was issued on behalf of the issuer's corporation
     * @type {boolean}
     * @memberof GetCorporationsCorporationIdContracts200Ok
     */
    forCorporation: boolean;
    /**
     * Character's corporation ID for the issuer
     * @type {number}
     * @memberof GetCorporationsCorporationIdContracts200Ok
     */
    issuerCorporationId: number;
    /**
     * Character ID for the issuer
     * @type {number}
     * @memberof GetCorporationsCorporationIdContracts200Ok
     */
    issuerId: number;
    /**
     * Price of contract (for ItemsExchange and Auctions)
     * @type {number}
     * @memberof GetCorporationsCorporationIdContracts200Ok
     */
    price?: number;
    /**
     * Remuneration for contract (for Couriers only)
     * @type {number}
     * @memberof GetCorporationsCorporationIdContracts200Ok
     */
    reward?: number;
    /**
     * Start location ID (for Couriers contract)
     * @type {number}
     * @memberof GetCorporationsCorporationIdContracts200Ok
     */
    startLocationId?: number;
    /**
     * Status of the the contract
     * @type {string}
     * @memberof GetCorporationsCorporationIdContracts200Ok
     */
    status: GetCorporationsCorporationIdContracts200OkStatusEnum;
    /**
     * Title of the contract
     * @type {string}
     * @memberof GetCorporationsCorporationIdContracts200Ok
     */
    title?: string;
    /**
     * Type of the contract
     * @type {string}
     * @memberof GetCorporationsCorporationIdContracts200Ok
     */
    type: GetCorporationsCorporationIdContracts200OkTypeEnum;
    /**
     * Volume of items in the contract
     * @type {number}
     * @memberof GetCorporationsCorporationIdContracts200Ok
     */
    volume?: number;
}


/**
 * @export
 */
export const GetCorporationsCorporationIdContracts200OkAvailabilityEnum = {
    Public: 'public',
    Personal: 'personal',
    Corporation: 'corporation',
    Alliance: 'alliance'
} as const;
export type GetCorporationsCorporationIdContracts200OkAvailabilityEnum = typeof GetCorporationsCorporationIdContracts200OkAvailabilityEnum[keyof typeof GetCorporationsCorporationIdContracts200OkAvailabilityEnum];

/**
 * @export
 */
export const GetCorporationsCorporationIdContracts200OkStatusEnum = {
    Outstanding: 'outstanding',
    InProgress: 'in_progress',
    FinishedIssuer: 'finished_issuer',
    FinishedContractor: 'finished_contractor',
    Finished: 'finished',
    Cancelled: 'cancelled',
    Rejected: 'rejected',
    Failed: 'failed',
    Deleted: 'deleted',
    Reversed: 'reversed'
} as const;
export type GetCorporationsCorporationIdContracts200OkStatusEnum = typeof GetCorporationsCorporationIdContracts200OkStatusEnum[keyof typeof GetCorporationsCorporationIdContracts200OkStatusEnum];

/**
 * @export
 */
export const GetCorporationsCorporationIdContracts200OkTypeEnum = {
    Unknown: 'unknown',
    ItemExchange: 'item_exchange',
    Auction: 'auction',
    Courier: 'courier',
    Loan: 'loan'
} as const;
export type GetCorporationsCorporationIdContracts200OkTypeEnum = typeof GetCorporationsCorporationIdContracts200OkTypeEnum[keyof typeof GetCorporationsCorporationIdContracts200OkTypeEnum];


/**
 * Check if a given object implements the GetCorporationsCorporationIdContracts200Ok interface.
 */
export function instanceOfGetCorporationsCorporationIdContracts200Ok(value: object): value is GetCorporationsCorporationIdContracts200Ok {
    if (!('acceptorId' in value) || value['acceptorId'] === undefined) return false;
    if (!('assigneeId' in value) || value['assigneeId'] === undefined) return false;
    if (!('availability' in value) || value['availability'] === undefined) return false;
    if (!('contractId' in value) || value['contractId'] === undefined) return false;
    if (!('dateExpired' in value) || value['dateExpired'] === undefined) return false;
    if (!('dateIssued' in value) || value['dateIssued'] === undefined) return false;
    if (!('forCorporation' in value) || value['forCorporation'] === undefined) return false;
    if (!('issuerCorporationId' in value) || value['issuerCorporationId'] === undefined) return false;
    if (!('issuerId' in value) || value['issuerId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function GetCorporationsCorporationIdContracts200OkFromJSON(json: any): GetCorporationsCorporationIdContracts200Ok {
    return GetCorporationsCorporationIdContracts200OkFromJSONTyped(json, false);
}

export function GetCorporationsCorporationIdContracts200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCorporationsCorporationIdContracts200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'acceptorId': json['acceptor_id'],
        'assigneeId': json['assignee_id'],
        'availability': json['availability'],
        'buyout': json['buyout'] == null ? undefined : json['buyout'],
        'collateral': json['collateral'] == null ? undefined : json['collateral'],
        'contractId': json['contract_id'],
        'dateAccepted': json['date_accepted'] == null ? undefined : (new Date(json['date_accepted'])),
        'dateCompleted': json['date_completed'] == null ? undefined : (new Date(json['date_completed'])),
        'dateExpired': (new Date(json['date_expired'])),
        'dateIssued': (new Date(json['date_issued'])),
        'daysToComplete': json['days_to_complete'] == null ? undefined : json['days_to_complete'],
        'endLocationId': json['end_location_id'] == null ? undefined : json['end_location_id'],
        'forCorporation': json['for_corporation'],
        'issuerCorporationId': json['issuer_corporation_id'],
        'issuerId': json['issuer_id'],
        'price': json['price'] == null ? undefined : json['price'],
        'reward': json['reward'] == null ? undefined : json['reward'],
        'startLocationId': json['start_location_id'] == null ? undefined : json['start_location_id'],
        'status': json['status'],
        'title': json['title'] == null ? undefined : json['title'],
        'type': json['type'],
        'volume': json['volume'] == null ? undefined : json['volume'],
    };
}

export function GetCorporationsCorporationIdContracts200OkToJSON(json: any): GetCorporationsCorporationIdContracts200Ok {
    return GetCorporationsCorporationIdContracts200OkToJSONTyped(json, false);
}

export function GetCorporationsCorporationIdContracts200OkToJSONTyped(value?: GetCorporationsCorporationIdContracts200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'acceptor_id': value['acceptorId'],
        'assignee_id': value['assigneeId'],
        'availability': value['availability'],
        'buyout': value['buyout'],
        'collateral': value['collateral'],
        'contract_id': value['contractId'],
        'date_accepted': value['dateAccepted'] == null ? undefined : ((value['dateAccepted']).toISOString()),
        'date_completed': value['dateCompleted'] == null ? undefined : ((value['dateCompleted']).toISOString()),
        'date_expired': ((value['dateExpired']).toISOString()),
        'date_issued': ((value['dateIssued']).toISOString()),
        'days_to_complete': value['daysToComplete'],
        'end_location_id': value['endLocationId'],
        'for_corporation': value['forCorporation'],
        'issuer_corporation_id': value['issuerCorporationId'],
        'issuer_id': value['issuerId'],
        'price': value['price'],
        'reward': value['reward'],
        'start_location_id': value['startLocationId'],
        'status': value['status'],
        'title': value['title'],
        'type': value['type'],
        'volume': value['volume'],
    };
}

